import { COLORS } from '@constants';
import { Icon, Tabs } from '@ui';
import styled from 'styled-components';

export const StyledChart = styled.div`
    height: 450px;
    width: 1279px;
    background: ${COLORS.$white};
    border: 1px solid ${COLORS.$gray15Black};
    border-radius: 8px;
    position: relative;
`;

export const ChartLabelsContainer = styled.div`
    display: flex;
    position: absolute;
    top: 10px;
    left: 20px;
    background: ${COLORS.$white};
    padding: 1px 6px;
`;

export const ChartLabel = styled.span`
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0;
    text-align: right;
    vertical-align: middle;
    color: ${COLORS.$black};
    & + & {
        margin-left: 20px;
    }
`;

export const TooltipWrapper = styled.div`
    position: absolute;
    top: 14px;
    right: 16px;
    z-index: 1;
`;

export const QuestionCircleIcon = styled(Icon.QuestionCircleIcon)`
    &:hover {
        color: ${COLORS.$gray40Black};
        cursor: pointer;
    }
`;

export const StyledTabs = styled(Tabs)`
    margin-bottom: 48px;

    & .ant-tabs-nav-list {
        justify-content: center;
    }
`;
